/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForJenkins extends models.ServiceAccountNativeDetailsBaseForIntegratedTool {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForJenkins");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForJenkins.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForJenkins>): ServiceAccountNativeDetailsForJenkins {
        let obj = Object.assign(new ServiceAccountNativeDetailsForJenkins(), model);
        ServiceAccountNativeDetailsForJenkins.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForJenkins>): ServiceAccountNativeDetailsForJenkins {
        if (!model) return null;
        return ServiceAccountNativeDetailsForJenkins.newInstance(<ServiceAccountNativeDetailsForJenkins> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForJenkins) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForJenkins.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForJenkins): boolean {
        if (models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForJenkins.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
